
let eventGuid = 0
let todayStr = new Date().toISOString().replace(/T.*$/, '') // YYYY-MM-DD of today

export const INITIAL_EVENTS = [
  {
    id: createEventId(),
    title: 'event1',//'All-day event',
    start: todayStr,
    url: '',
    extendedProps: {
      department: 'BioChemistry',
      url:'/api/membership/GetSquareImage?username=erikbohm@hotmail.com'
    },
  },
  //{
  //  id: createEventId(),
  //  title: 'Timed event',
  //  start: todayStr + 'T12:00:00'
  //}
]

export function createEventId() {
  return String(eventGuid++)
}



// WEBPACK FOOTER //
// ./src/components/calander/event-utils.js